<div class="container d-flex mt-4 justify-content-center align-items-center login-shell">
  <div class="row w-100 justify-content-center">
    <div class="col-sm-12 col-md-7 col-lg-5 ">
      <div class="logo-slot mb-2 mx-auto">
        @if (!isLogoLoaded()) {
        <div class="logo-placeholder d-flex align-items-center justify-content-center" aria-hidden="true">
          <div class="spinner-border spinner-border-sm text-primary" role="status" aria-label="Cargando logo">
            <span class="visually-hidden">Cargando logo</span>
          </div>
        </div>
        }
        <img #logoImage [src]="logoUrl()" (load)="onLogoImageLoad()" alt="Logo" class="logo-image"
          [class.logo-image-hidden]="!isLogoLoaded()" crossorigin="anonymous">
      </div>
      <div class="card shadow">

        <div class="card-body">
          <h3 class="card-title text-center mb-2">Ingresar</h3>
          <form #loginForm="ngForm" (ngSubmit)="login()" class="login-form">
            <div class="mb-2">
              <label for="username" autocomplete="username webauthn" class="form-label required">Usuario</label>
              <input [ngModelOptions]="{ updateOn: 'change' }" [appAutofocus]="true" type="text"
                autocomplete="username" id="username" class="form-control form-control-lg"
                [(ngModel)]="request.username" name="username" required>
            </div>

            <div class="mb-2">
              <label for="password" class="form-label required">Contraseña</label>
              <div class="input-group input-group-lg">
                <input [ngModelOptions]="{ updateOn: 'change' }" [type]="showPassword() ? 'text' : 'password'"
                  autocomplete="current-password" id="password" class="form-control"
                  [(ngModel)]="request.password" name="password" required>
                <button type="button" class="btn btn-outline-secondary"
                  (click)="showPassword.set(!showPassword())"
                  [attr.aria-label]="showPassword() ? 'Ocultar contraseña' : 'Mostrar contraseña'"
                  [attr.aria-pressed]="showPassword()">
                  <i [class]="showPassword() ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div class="d-grid gap-2 mt-1">
              <button type="submit" class="btn btn-primary" [disabled]="!form?.valid"
                [appProcessing]="submitting()">Ingresar</button>
            </div>
            <div class="text-center mt-3">
              @if (biometricsEnabled()) {
              <div class="d-grid gap-2 mt-1">
                <button type="button" class="btn btn-outline-secondary" [disabled]="!form?.valid"
                  (click)="loginAndRegister()"
                  [appProcessing]="submittingRegistration()">Ingresar y registrar huella, rostro o PIN</button>
              </div>
              }
              <button type="button" (click)="forgotPassword()" class="btn btn-link forgot-password-link">¿Olvidaste tu
                contraseña?</button>
            </div>

            @if (message()){
            <small class="text-danger mt-2 d-block" role="alert">
              {{ message() }}
            </small>
            }

            @if (biometricsEnabled()) {
            <div class="biometric-section mt-2">
              <div class="biometric-divider">
                <span>o continúa con</span>
              </div>
              <div class="small text-muted mb-2 biometric-help">
                Para usar huella, rostro o PIN:
                <ul class="mb-0 ps-3">
                  <li>1. Ingresa usuario y contraseña</li>
                  <li>2. Presiona Ingresar y registrar Rostro/Huella/Pin</li>
                </ul>
              </div>
              <button type="button" class="btn btn-outline-primary biometric-btn w-100" (click)="loginBiometrics()"
                aria-label="Ingresar con biometría">
                <img src="biometrics.png" alt="" class="biometric-icon" />
                <span>Ingresar con huella, rostro o PIN</span>
              </button>
            </div>
            }


          </form>
        </div>
      </div>
    </div>
  </div>
</div>